enum CampaignFileStatus {
  New = 'New',
  Imported = 'Imported',
}

export default CampaignFileStatus;
